import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/DeleteAccount.css";

import axiosBaseURL from '../httpCommon.js';

const UserAccountDelete = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [jwtToken, setJwtToken] = useState(null);
  const [userId, setUserId] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage("");
    try {
      
      const response = await axiosBaseURL.post(`/users/authenticate`, { username, password });
      
      if (response.data.statusCode === 200 ) {
        setJwtToken(response.data.data.token);
        setUserId(response.data.data.id);
        setShowConfirm(true);
      } else {
        setMessage("Invalid user details");
      }
    } catch (error) {
      setMessage("Error logging in. Try again later.");
    }
    
  };

   
  const handleDelete = async () => {
    setShowConfirm(false);
    try {
     
      const response = await axiosBaseURL.delete(`/users/${userId}`, { headers: { "Authorization": `Bearer ${jwtToken}` } });
      
      if (response.data.statusCode === 204) {
        setMessage("Account successfully deleted.");
      } else {
        setMessage("Failed to delete account.");
      }
    } catch (error) {
      setMessage("Error deleting account. Try again later.");
    }
  };

  return (
    <>
      <header className="delete-account-header">
        <div className="delete-account-header__inner">
          <Link className="delete-account-header__brand" to="/" aria-label="Cling home">
            <img src={require("../images/logo.svg").default} alt="Cling" />
          </Link>

          <nav className="delete-account-header__nav" aria-label="Delete account navigation">
            <Link to="/">Home</Link>
            <Link to="/PrivacyPolicy">Privacy</Link>
            <Link to="/VideoPlayer">Explainer</Link>
          </nav>

          <Link className="delete-account-header__home" to="/">
            Back to Home
          </Link>
        </div>
      </header>

      <div className="delete-account-page">
        <div className="delete-account-page__glow delete-account-page__glow--left" aria-hidden="true" />
        <div className="delete-account-page__glow delete-account-page__glow--right" aria-hidden="true" />
        <div className="del-container">
          <p className="del-container__eyebrow">Account support</p>
          <h4>Delete your Cling account</h4>
          <p className="del-container__intro">
            Sign in with your existing credentials to verify ownership of the account before
            continuing with deletion.
          </p>

          <form className="del-container__form" onSubmit={handleLogin}>
            <input
              className="del-container__input"
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <input
              className="del-container__input"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button className="del-container__button" type="submit">Continue</button>
          </form>

          {message && <p className="del-container__message">{message}</p>}

          {showConfirm && (
            <div className="modal">
              <div className="modal-content">
                <p className="modal-content__title">Are you sure you want to delete your account?</p>
                <p className="modal-content__copy">
                  This action is intended for permanent account removal. Please confirm only if you are
                  ready to proceed.
                </p>
                <div className="modal-content__actions">
                  <button className="del-container__button del-container__button--danger" onClick={handleDelete}>Yes, Delete</button>
                  <button className="del-container__button del-container__button--secondary" onClick={() => setShowConfirm(false)}>Cancel</button>
                </div>
              </div>
            </div>
          )}
          </div>
      </div>
    </>
    
  );
};

export default UserAccountDelete;
